var _radialGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2501.34 2500",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2499,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 2329.27,
    cy: 2305.82,
    gradientTransform: "matrix(1.09 0 0 -1.09 -110.8 2605.56)",
    gradientUnits: "userSpaceOnUse",
    r: 2638.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c711e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f52ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2501.34 2500H0V0h2501.34L1224.87 1231.44z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin2);
export default __webpack_public_path__ + "static/media/kotlin-2.7f13d1fd42ec47e3522493518ae6f5ec.svg";
export { ForwardRef as ReactComponent };